import { Component, computed, signal } from '@angular/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { TextAreaComponent } from '../../../shared/components/forms/text-area/text-area.component';
import { AnimateOpenDirective } from '../../../shared/directives/animate-open.directive';

@Component({
  selector: 'app-vulnerable-customers',
  imports: [TextAreaComponent, ButtonComponent, AnimateOpenDirective],
  templateUrl: './vulnerable-customers.component.html',
  styleUrl: './vulnerable-customers.component.scss',
  host: {
    class: 'full-width max-w-760 mx-auto mb-20',
  },
})
export class VulnerableCustomersComponent {
  open = signal(false);
  showWarningMessage = false;
  needsSubmitted = false;
  buttonsHidden = false;

  private viewModel = computed(() => {
    return {
      open: this.open(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  saveAndSubmit() {
    this.showWarningMessage = true;
    this.buttonsHidden = true;
  }

  handleSubmit() {
    this.needsSubmitted = true;
  }
}
